import React, { useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import Breadcrumbs from "components/Common/Breadcrumb"
import CreateTeamFilter from "./createTeamFilter"
import { createTeam, getTeamLookup, getTeams } from "store/createTeam/action"
import moment from "moment"
import toast from "toastr"
import Accordian from "./accordian"
import {
  Card,
  CardBody,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap"
import ManageTeamForm from "../component/teamModal"
import { isEmpty } from "lodash"
import { HubConnectionBuilder, LogLevel } from "@microsoft/signalr"
import { getAuthorizationToken } from "helpers/storagehelper"

const Create_Team = props => {
  const dispatch = useDispatch()
  const [filtersubCategory, setfiltersubCategory] = useState([])
  const [filterUserData, setfilterUserData] = useState([])
  const [selectedUserData, setuserList] = useState(null)
  const [selectedSubcategory, setselectedSubcategory] = useState(null)
  const [selectedMainCategory, setselectedMainCategory] = useState(null)
  const [selectedReport, setselectedReport] = useState(null)
  const [selectedSupervisor, setselectedSupervisor] = useState(null)
  const [startDate, setStartDate] = useState(new Date())
  const [selectedData, setselectedData] = useState({})
  const [modal, setModal] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [handleAccordion, sethandleAccordion] = useState(false)
  const [connection, setconnection] = useState(null)
  const [sendMessage, setsendMessage] = useState(null)

  const userid = JSON.parse(localStorage.getItem("authUser") || "{}")?.data?.id
  const accessgroupId = JSON.parse(localStorage.getItem("authUser") || "{}")
    ?.data?.useraccessgroupsettings?.accessgroupid
  const accessgroupname = JSON.parse(localStorage.getItem("authUser") || "{}")
    ?.data?.accessgroupname
  const loginUser = JSON.parse(localStorage.getItem("authUser") || "{}")?.data
    ?.user_name

  useEffect(() => {
    const tempdata = accessgroupname === "Supervisor" ? loginUser : null
    setselectedSupervisor(tempdata)
  }, [])

  const params = {
    categoryid: 0,
    subcategoryid: 0,
    reporttoid: 0,
    userId: userid,
    startDate: "",
    endDate: "",
    useridList: [],
    pagesize: 0,
    pagenumber: 0,
    supervisorid: userid,
  }
  // handle signalr
  useEffect(() => {
    const connect = new HubConnectionBuilder()
      // Hub now requires auth: supply the JWT. @microsoft/signalr sends it as a
      // Bearer header on negotiate and as the "access_token" query value on the socket.
      .withUrl(`${process.env.REACT_APP_API_URL}/MessageHub`, {
        accessTokenFactory: () => getAuthorizationToken(),
      })
      .configureLogging(LogLevel.Information)
      .withAutomaticReconnect()
      .build()
    // console.log('connect', connect)
    setconnection(connect)

    setsendMessage(
      " {'userid':1,'usercurrentactivity':{'name':'Saravanan','email':'prabhuc@tendersoftware.in','deviceId':'BF4C8C1F - 87AD - 4F1F - 85A1 - BF490CD2FCF8','timezone':'India Standard Time','projectName':'TenderSoftwareIndiaPtyLtd Bench','ipAddress':'61.3.255.249','activity':'ACTIVE','windowName':'studio64.exe','windowTitle':'flexitrac  app_service_signalr.dart[flexitrac]'}}"
    )
  }, [])

  useEffect(() => {
    if (connection) {
      connection
        .start()
        .then(() => {
          connection
            .invoke("OnConnected", "Manager")
            .then(() => {
              console.log("Group Connected")
            })
            .catch(function (err) {
              //return console.error(err.toString());
              console.log(err.toString())
            })
        })
        .catch(error => console.log(error))
      connection.on("SendMessageToGroup", function (receivedMessages) {
        if (JSON.parse(receivedMessages).SENDER === "System") {
          console.log("")
        } else {
          toast.success(receivedMessages)
        }
        // BindGroupToGrid(receivedMessages);
      })
      // connection.start()
      // .then(() => connection.invoke("sendMessageToAllClients", "Hello"));

      // connection.on("sendMessageToGroup", (message) => {
      //   console.log(message,'dataaaaaa');
      // })

      // connection.invoke("sendMessageToAllClients","hello data").then(()=>{}).catch(()=>{});
      // connection.invoke("sendMessageToGroup","hello data",companyName).then(()=>{}).catch(()=>{});
    }
  }, [connection])

  // Handle API Call
  useEffect(() => {
    dispatch(getTeamLookup())
    dispatch(getTeams(params))
  }, [])

  const {
    teamList,
    createteamlist,
    getTeamsData,
    companySetting,
    updateteams,
  } = useSelector(state => ({
    teamList: state?.createteam?.createTeamLookupList,
    createteamlist: state?.createteam?.createTeamList,
    getTeamsData: state?.createteam?.responseTeam,
    companySetting: state?.Login?.userDetails?.data,
    updateteams: state?.createteam?.updateteams,
  }))

  useEffect(() => {
    if (createteamlist?.statusCode === 200) {
      dispatch(getTeams(params))
    }
  }, [createteamlist])

  useEffect(() => {
    if (updateteams?.message === "Team updated successfully") {
      
      dispatch(getTeams(params))
    }
  }, [updateteams])

  // handle Main Category
  const categoryFilter = value => {
    setselectedMainCategory(value)
    setselectedSubcategory(null)
  }
  // handle report data
  const reportfilter = value => {
    setuserList(null)
    isEmpty(selectedSupervisor) && setselectedSupervisor(null)
    setselectedReport(value)
  }
  const supervisorfilter = value => {
    setuserList(null)
    setselectedSupervisor(value)
  }
  useEffect(() => {
    // Members may be of any designation (incl. higher than the creator): a higher-designation user can
    // work under a next-level employee for a project. Loops are prevented server-side, not by rank.
    const filtedredUser = teamList?.teamMemberLookup?.filter(
      el =>
        el.userName !== selectedReport?.userName &&
        el.userName !== selectedSupervisor?.userName
    )
    setfilterUserData(filtedredUser)
  }, [selectedReport, selectedSupervisor])

  // handle Sub-category
  const subcategoryFilter = value => {
    setselectedSubcategory(value)
  }

  //handle selectedUserData
  const userListFilter = value => {
    setuserList(value)
  }
  //Filter sub-categoryDrop-down
  useEffect(() => {
    const filteredData = selectedMainCategory?.id
      ? teamList?.subCategoryLookup?.filter(
          el => el?.categoryId === selectedMainCategory?.id
        )
      : teamList?.subCategoryLookup
    setfiltersubCategory(filteredData)
  }, [selectedMainCategory])

  useEffect(() => {
    setfiltersubCategory(teamList?.subCategoryLookup)
    // Members may be of any designation; rank no longer caps the selectable member list.
    setfilterUserData(teamList?.teamMemberLookup)
  }, [teamList])

  // Handle submit

  const handlesubmit = () => {
    if (selectedMainCategory?.id === undefined) {
      toast.error(`Select ${companySetting.MainCategory}`)
    } else if (selectedReport?.userId === undefined) {
      toast.error("Select Report Manager")
    } else if (isEmpty(startDate.toString())) {
      toast.error("Select Start Date")
    } else if (selectedSupervisor?.userId === undefined) {
      toast.error("Select Supervisor")
    } else if (selectedUserData?.length === undefined) {
      toast.error("Select User")
    } else {
      const params = {
        categoryId: selectedMainCategory?.id,
        subCategoryId: selectedSubcategory?.id,
        reportTo: selectedReport?.userId,
        supervisorId: selectedSupervisor?.userId
          ? selectedSupervisor?.userId
          : userid,
        teammembers: (selectedUserData || []).map(item => ({
          userId: item.userId,
        })),
        startDate: moment(new Date(startDate)).format("YYYY-MM-DD"),
        createdBy: userid,
        createdAt: moment(new Date()).format("YYYY-MM-DD"),
        teamuserId: 0,
        teamsupervisorId: 0,
        teamdurationId: 0,
      }
      dispatch(createTeam(params, handleResponse))
    }
  }
  const handleResponse = status => {
    if (status === "SUCCESS") {
      setuserList(null)
      selectedSupervisor !== "Supervisor" && setselectedSupervisor(null)
      setselectedSubcategory(null)
      setselectedMainCategory(null)
      setselectedReport(null)
      setStartDate(new Date())
    }
  }
  const handleCancel = () => {
    if (modal) {
      setModal(false)
    } else {
      setModal(true)
    }
  }
  const handleTeamCancel = () => {
    setuserList(null)
    setselectedSupervisor(null)
    setselectedSubcategory(null)
    setselectedMainCategory(null)
    setselectedReport(null)
    setStartDate(new Date())
  }
  const toggle = () => {
    if (modal) {
      setModal(false)
    } else {
      setModal(true)
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xs="12">
              <Breadcrumbs
                title={"Create Team"}
                breadcrumbItem={"Create Team"}
              />
              <Card>
                <CardBody>
                  <CreateTeamFilter
                    teamList={teamList}
                    userListFilter={userListFilter}
                    selectedUserData={selectedUserData}
                    setStartDate={setStartDate}
                    startDate={startDate}
                    categoryFilter={categoryFilter}
                    selectedMainCategory={selectedMainCategory}
                    subcategoryFilter={subcategoryFilter}
                    selectedSubcategory={selectedSubcategory}
                    filtersubCategory={filtersubCategory}
                    reportfilter={reportfilter}
                    selectedReport={selectedReport}
                    buttonname="ADD"
                    handlesubmit={handlesubmit}
                    selectedData={selectedData}
                    handleTeamCancel={handleTeamCancel}
                    companySetting={companySetting}
                    accessgroupId={accessgroupId}
                    filterUserData={filterUserData}
                    selectedSupervisor={selectedSupervisor}
                    supervisorfilter={supervisorfilter}
                    isDisable={accessgroupname === "Supervisor"}
                  />
                </CardBody>
              </Card>
              <Card>
                <CardBody>
                  <Breadcrumbs title={"Teams"} breadcrumbItem={"Teams"} />
                  {getTeamsData?.data?.map(item => {
                    return (
                      <Accordian
                        key={`${item.categoryid}_${item.subcategoryid}_${item.supervisorid}`}
                        item={item}
                        setselectedData={setselectedData}
                        setStartDate={setStartDate}
                        setIsEdit={setIsEdit}
                        toggle={toggle}
                        sethandleAccordion={sethandleAccordion}
                        handleAccordion={handleAccordion}
                        keyId={`${item.categoryid}_${item.subcategoryid}_${item.supervisorid}`}
                      />
                    )
                  })}
                  {getTeamsData?.data?.length == 0 ? (
                    <div className="d-flex justify-content-center">
                      No Teams Matches for the Selected Combinations
                    </div>
                  ) : (
                    ""
                  )}
                  {modal && (
                    <Modal isOpen={modal} toggle={toggle} size="xl">
                      <ModalHeader toggle={toggle} tag="h4">
                        {"Edit Create Team"}
                      </ModalHeader>
                      <ModalBody>
                        <ManageTeamForm
                          filtersubCategory={filtersubCategory}
                          toggle={toggle}
                          selectedData={selectedData}
                          handleCancel={handleCancel}
                          setfiltersubCategory={setfiltersubCategory}
                          startDate={startDate}
                          teamList={teamList}
                          setStartDate={setStartDate}
                          setselectedData={setselectedData}
                          isEdit={isEdit}
                          companySetting={companySetting}
                          accessgroupname={accessgroupname}
                          disable={accessgroupname === "Supervisor"}
                        />
                      </ModalBody>
                    </Modal>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Create_Team
